import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import Breadcrumbs from '../../../layout/Breadcrumbs';
import TableToolbar from '../../../common/TableToolbar';
import {
  NEW_ITINERARY_REPORT_PATH,
  ITINERARY_REPORTS_PATH,
} from '../../../../config/paths';
import Table from '../../../common/Table';
import {
  clearItineraryReports,
  getItineraryReports,
  clearErrorGettingItineraryReports,
} from '../../../../actions';
import Alert from '../../../common/informative/Alert';
import { REPORT_COLUMNS } from '../../../../config/columns';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

class ItineraryReports extends Component {
  constructor(props) {
    super(props);
    this.columns = REPORT_COLUMNS;
  }

  componentWillUnmount() {
    this.props.clearErrorGettingItineraryReports();
    this.props.clearItineraryReports();
  }

  renderContent() {
    const { reports, loading, error } = this.props;

    // check if there is an error
    if (error) {
      return <Alert message={error} />;
    }

    let data = [];
    let pages = null;
    let defaultPageSize = DEFAULT_PAGE_SIZE;

    const { columns } = this;

    if (reports) {
      data = reports.get('content');
      pages = reports.get('totalPages');
      defaultPageSize = reports.get('size');
    }

    return (
      <Table
        columns={columns}
        data={data}
        pages={pages}
        defaultPageSize={defaultPageSize}
        fetchData={this.props.getItineraryReports}
        modelPath={ITINERARY_REPORTS_PATH}
        loading={loading}
        navigateToModelOnRowClick
      />
    );
  }

  render() {
    return (
      <Container fluid>
        <Breadcrumbs breadcrumbs={this.props.breadcrumbs} />
        <TableToolbar buttonPath={NEW_ITINERARY_REPORT_PATH} />
        <h1>Reportes de Itinerarios</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
        {this.renderContent()}
      </Container>
    );
  }
}

const mapStateToProps = ({ ReportUnit }) => ({
  breadcrumbs: [
    ...ReportUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Itinerarios',
      href: ITINERARY_REPORTS_PATH,
    },
  ],
  reports: ReportUnit.ItineraryReport.get('all').get('content'),
  loading: ReportUnit.ItineraryReport.get('all').get('loading'),
  error: ReportUnit.ItineraryReport.get('all').get('error'),
});

const mapDispatchToProps = {
  getItineraryReports,
  clearItineraryReports,
  clearErrorGettingItineraryReports,
};

ItineraryReports.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  getItineraryReports: PropTypes.func.isRequired,
  clearItineraryReports: PropTypes.func.isRequired,
  clearErrorGettingItineraryReports: PropTypes.func.isRequired,
  reports: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  error: PropTypes.string,
};

ItineraryReports.defaultProps = {
  reports: null,
  loading: false,
  error: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(ItineraryReports);
